import { render, staticRenderFns } from "./EditMutationSegment.vue?vue&type=template&id=64c568e2&scoped=true"
import script from "./EditMutationSegment.vue?vue&type=script&lang=js"
export * from "./EditMutationSegment.vue?vue&type=script&lang=js"
import style0 from "./EditMutationSegment.vue?vue&type=style&index=0&id=64c568e2&prod&lang=css"
import style1 from "./EditMutationSegment.vue?vue&type=style&index=1&id=64c568e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c568e2",
  null
  
)

export default component.exports